"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagementGroupType = void 0;
var ManagementGroupType;
exports.ManagementGroupType = ManagementGroupType;
(function (ManagementGroupType) {
  ManagementGroupType["Service"] = "Service";
  ManagementGroupType["TeamGroup"] = "TeamGroup";
  ManagementGroupType["ServiceGroup"] = "ServiceGroup";
  ManagementGroupType["Organization"] = "Organization";
  ManagementGroupType["Division"] = "Division";
  ManagementGroupType["Unknown"] = "Unknown";
})(ManagementGroupType || (exports.ManagementGroupType = ManagementGroupType = {}));